import { useEffect, useState } from 'react'
import ElectronIPC from '../services/ElectronIPC'
import { env } from '../services/EnvironmentVariables'
import { persistent } from '../services/LocalStorage'
import { Dialog } from '@/components/Dialog'
import { Button } from '@/UIComponents2/Button'

export default function ShowRestartRequiredDialog() {
    const [show, set_show] = useState(false)

    useEffect(() => {
        if (env.IS_ELECTRON && env.OS === 'darwin') {
            // on macos, the installer should have created this file if
            // components which require a restart has been installed.
            // the file's content is a unix timestamp.
            const markFilePath = '/tmp/muse_show_restart_required_dialog'

            ElectronIPC.readFile(markFilePath).then((str) => {
                if (!str) {
                    return
                }

                const value = parseInt(str)
                const lastValue = persistent.getInt('restart_required_dialog_suppressed_value')

                // we do this to prevent the dialog from showing every time the user
                // opens the app even though they have clicked "later".
                if (!lastValue || value > lastValue) {
                    set_show(true)
                }

                persistent.set('restart_required_dialog_suppressed_value', value)
            })
        }
    }, [])

    const onDefaultClose = () => {
        set_show(false)
    }

    const onAction = () => {
        // restart the computer.
        ElectronIPC.systemReboot()
    }

    if (!show) {
        return null
    }

    return (
        <Dialog open={true} onClose={onDefaultClose} title="Restart Required">
            <div className="px-5">
                <h2 className="text-[32px] font-medium">{`You need to restart your computer to complete the installation!`}</h2>

                <div className="my-6">
                    Muse audio drivers have been installed or upgraded. You need to restart your computer or some
                    features may not work.
                </div>
            </div>

            <div className="flex gap-2 w-full pt-4">
                <Button variant="secondary" className="flex-1" onClick={onDefaultClose}>
                    Later
                </Button>
                <Button variant="primary" className="flex-1" onClick={onAction}>
                    Restart computer
                </Button>
            </div>
        </Dialog>
    )
}
